(function() {
fanplayr.define('platform/loader',['require','fanplayr','platform/jquery','platform/utils'],function(require) {
  var fanplayr = require('fanplayr');
  var $ = require('platform/jquery');
  var _ = require('platform/utils');

  var loader = fanplayr.loader;
  var services = fanplayr.services = (fanplayr.services || {});

  var api = {
    load: function ( name, callback ) {
      require([loader.uri(name)], function () {
        var baseName = name.split("/").pop();
        var entry = name + "/" + baseName;
        require([entry], function ( obj ) {
          if ( callback ) {
            callback(null, obj);
          }
          services[baseName] = obj;
        });
      });
    },

    loadAdaptor: function ( name, callback ) {
      require([loader.uri("adaptors/" + name + "/latest/" + name + ".min.js")], function () {
        require(["adaptors/" + name + "/index"], function ( adaptor ) {
          if ( callback ) {
            callback(adaptor);
          }
          fanplayr.adaptor = adaptor;
        });
      });
    },

    getAssetsFor: function ( resource ) {
      return new Assets(loader.base(resource));
    },

    debug: loader.debug,

    adaptor: loader.adaptor,

    params: loader.params,

    uri: loader.uri,

    base: loader.base
  };

  var loaderPattern = /(?:d38nbbai6u794i|fanplayr).*?loader\.js(.*)/i;
  var scripts = document.getElementsByTagName("script");
  for ( var i = 0; i < scripts.length; i++ ) {
    if ( loaderPattern.test(scripts[i].src) ) {
      api.params = _.parseUrl(scripts[i].src).params;
      break;
    }
  }

  function Assets ( basePath ) {
    this.basePath = basePath;
  }

  Assets.prototype = {
    getUrl: function ( file ) {
      return /^(?:https?:)?\/\//.test(file) ? file : this.basePath + "/assets/" + file;
    },

    loadCss: function ( file, options ) {
      options = options || {};
      var html = '<link rel="stylesheet" type="text/css" href="' + this.getUrl(file) + '"';
      if ( !options.doc ) {
        options.doc = document;
      }
      if ( options.id ) {
        $("#" + options.id, options.doc).remove();
        html += ' id="' + options.id + '" ';
      }
      html += ' />';
      $("head", options.doc).append(html);
    },

    inlineCss: function ( id, content, options ) {
      options = options || {};
      $("#" + id, options.doc).remove();
      $("head", options.doc).append('<style type="text/css" id="' + id + '">' + content + '</style>');
    }
  };

  return api;

});

fanplayr.define('services/offers/i18n/ar',[],function () {
  return function ( i18n ) {
    i18n.register("ar", {
      dateFormat: "%Y %B %d",

      minimumPurchase: "الشراء بقيمة { offer.minimumPurchase | currency } أو أكثر.",
      noMinimumPurchase: "لا يوجد حد أدنى للشراء. ",
      expires: "ينتهي في { offer.expires | date }. ",
      conditionsApply: "الشروط تنطبق",
      addToWalletBtn: "أحصل على العرض.",

      conditionsHeading: "الشروط",

      collectHeading: "أدخل البريد الإلكتروني الخاص بك لتفعيل القسيمة",
      collectEmailPlaceholder: "ادخل البريد الإلكتروني",
      collectEmailSkip: "واصل",
      collectSubmitBtn: "إشترك",

      noOfferError: "نأسف لحصول خطأ",

      offerDollarOff: "خصم { offer.value | currency }",
      offerPercentOff: "{ offer.value }٪ خصم",
      offerFreeShipping: "شحن مجاني",
      offerSessionOnly: "قابلة للاستبدال خلال هذه الزيارة فقط.",

      walletHeading: "محفظتك - اختر عرض واحد مع كل عملية شراء",
      walletCloseBtn: "إغلاق المحفظة",
      walletEmpty: "لم تقم بتجميع أي عرض بعد.",
      applyToCartBtn: "استخدم رمز الخصم",

      helpHeading: "كيف تعمل؟",
      helpCloseBtn: "اغلاق المساعدة",
      helpText: [
        "# الحصول على العرض.",
        "للإستفادة من هذا العرض، قم بالطلب بالضغط \"أضف إلى محفظتي\" باستخدامك للبريد الإلكتروني أو حساب الفيسبوك الخاص بك. ستنتبه لوجود رمز مخصص للإستبدال خلال إتمامك لعملية الشراء. كما وستتم إضافته لمحفظتك لتتمكن من الإستمرار بالتصفح واستخدام العرض المقدم لك متى رغبت.",
        "# استخدام المحفظة",
        "لتتمكن من عرض المحفظة الخاصة بك، إضغط على { wallet.helpIconHtml } المخصص. ستظهر لك قائمة تحتوي على العروض التي قمت باختيارها. بالضغط على الرمز المخصص سنقوم بعرض عربة التسوق الخاصة بك وعندها سيحسم الخصم أوتوماتيكياً. استخدم أي من العروض التي قمت بجمعها. بإمكانك استخدام عرض واحد فقط في كل عملية شراء.",
        "# نصائح",
        "- قد تظهر العروض لمرة واحدة فقط. تأكد من تجميعك لهم في حال ظهورهم مباشرةً.",
        "- في معظم الحالات، ستكون المحفظة صالحة للزيارة الحالية فقط. لذا تأكد أن تستفيد من المزايا الممنوحة قبل مغادرتك للموقع.",
        "- يمكن الإطلاع واستخدام المحافظ من أي صفحة على الموقع  لتتمكن من تصفح الموقع وفتح المحفظة عند استعدادك للشراء."
      ].join("\n"),

      monthsLong: ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونية", "يولية", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],

      mobileWalletHeader: "كوبونات"
    });
  };
});

fanplayr.define('services/offers/i18n/de',[],function () {
  return function ( i18n ) {
    i18n.register("de", {
      dateFormat: "%d. %B %Y",

      minimumPurchase: "Mindestbestellwert { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "Kein Mindestbestellwert. ",
      expires: "Gültig bis { offer.expires | date }. ",
      conditionsApply: "Bedingungen",
      addToWalletBtn: "Zur Wallet hinzufügen",

      conditionsHeading: "Bedingungen",

      collectHeading: "Geben Sie Ihre E-Mail Adresse ein, um dieses Angebot zu aktivieren",
      collectEmailPlaceholder: "Geben Sie Ihre E-Mail Adresse ein",
      collectEmailSkip: "Auslassen",
      collectSubmitBtn: "Absenden",

      noOfferError: "Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite erneut.",

      offerDollarOff: "{ offer.value | currency } Rabatt",
      offerPercentOff: "{ offer.value } % Rabatt",
      offerFreeShipping: "Versandkostenfrei",
      offerSessionOnly: "Nur während dieses Besuchs einlösbar.",

      walletHeading: "Ihre Wallet - wählen Sie ein Angebot pro Einkauf",
      walletCloseBtn: "Wallet schliessen",
      walletEmpty: "Sie haben bisher keine Angebote gesammelt.",
      applyToCartBtn: "Auf Warenkorb anwenden",

      helpHeading: "Wie es funktioniert",
      helpCloseBtn: "Hilfe schliessen",
      helpText: [
        "# Angebot in Anspruch nehmen",
        "Um von einem Angebot zu profitieren, wählen Sie es aus, indem Sie es zu Ihrer Wallet hinzufügen. Nutze,Sie dazu den Login über Facebook oder Ihre E-Mail Adresse. Anschliessend bekommen Sie einen Code angezeigt, den Sie im Warenkorb einlösen können. Der Code wird ausserdem Ihrer Wallet hinzugefügt sodass Sie ihn einlösen können wenn Sie mit Ihrem Einkauf fertig sind.",
        "# Nutzung der Wallet",
        "Um den Inhalt Ihrer Wallet zu sehen, klicken Sie auf dieses Icon { wallet.helpIconHtml }. Sie bekommen dor,einen Überblick über alle Angebote, die sie gesammelt haben. Durch Klicken auf 'Auf Warenkorb anwenden' wird Ihr aktueller Warenkorb angezeigt und der Rabatt wird automatisch angewand. Sie können jedes beliebige vorher gesammelte Angebot verwenden, jedoch nur ein Angebot pro Einkauf.",
        "# Tipps",
        "- Angebote werden nur einmalig angezeigt. Denken Sie daran, diese direkt einzusammeln, sobald si,angezeit werden.",
        "- In den meisten Fällen sind die Angebote in Ihrer Wallet nur für die Dauer des jeweiligen Besuchs au,der Seite gültig. Stellen Sie sicher die Angebote einzuösen, bevor Sie die Seite verlassen.",
        "- Die Wallet kann von jeder Seite eines Shop zugegriffen werden. Sie können die Wallet also jederzei,verlassen, um Ihren Besuch fortzusetzen und zurückkehren sobald Sie Ihren Einkauf abgeschlossen haben."
      ].join("\n"),

      monthsLong: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],

      mobileWalletHeader: "Angebote"
    });
  };
});

fanplayr.define('services/offers/i18n/en',[],function () {
  return function ( i18n ) {
    i18n.register("en", {
      dateFormat: "%b %e, %Y",

      minimumPurchase: "On any purchase over { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "No minimum purchase required. ",
      expires: "Offer expires { offer.expires | date }. ",
      conditionsApply: "Conditions Apply",
      addToWalletBtn: "Add to Wallet",

      conditionsHeading: "Conditions",

      collectHeading: "Enter your email to collect this offer",
      collectEmailPlaceholder: "Enter your email",
      collectEmailSkip: "Skip",
      collectSubmitBtn: "Submit",

      noOfferError: "Sorry, an error occurred. Please try refreshing your browser.",

      offerDollarOff: "{ offer.value | currency } Off",
      offerPercentOff: "{ offer.value }% Off",
      offerFreeShipping: "Free Shipping",
      offerSessionOnly: "Redeemable during this visit only.",

      walletHeading: "Your Wallet - Choose 1 Offer per Purchase",
      walletCloseBtn: "Close Wallet",
      walletEmpty: "You haven't collected any offers yet.",
      applyToCartBtn: "Apply to Cart",

      helpHeading: "How It Works",
      helpCloseBtn: "Close Help",
      helpText: [
        "# Claiming the Offer",
        "As you navigate the site, you may receive one or more offers.",
        "Each offer you receive will be collected into a wallet.",
        "To make use of an offer, scroll through your wallet, choose the one that best fits your interest and redeem it by clicking the Apply to Cart button or by keying in a promo code if one is displayed. In many cases, the Apply to Cart button will only be visible at checkout.",
        "# Using the Wallet",
        "To view your wallet, click on the icon that looks like this { wallet.helpIconHtml }.",
        "You will likely receive more than one offer during your visit.",
        "Do not be concerned if the latest offer seems to replace a previous offer that you were interested in.",
        "It will still be present in your wallet and you will be able to redeem it at checkout.",
        "Feel free to continue browsing and use an offer when you are ready.",
        "# Tips",
        "- If you apply the wrong offer or if for any reason you want to change the offer that you have previously applied; in most cases you will be required to delete the previously applied offer from the cart before it will accept the replacement offer.",
        "- The contents of your wallet is valid for the current visit only, so make sure to take advantage before leaving the site. Wallets can be viewed and used from any page on the site so browse away and open your wallet when you’re ready to purchase."
      ].join("\n"),

      mobileWalletHeader: "Offers"
    });
  };
});

fanplayr.define('services/offers/i18n/es',[],function () {
  return function ( i18n ) {
    i18n.register("es", {
      dateFormat: "%d de %B %Y",

      minimumPurchase: "Con una compra mínima de { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "No se requiere compra mínima. ",
      expires: "Expira { offer.expires | date }. ",
      conditionsApply: "Condiciones Adicionales",
      addToWalletBtn: "Agrega al portafolio",

      conditionsHeading: "Condiciones",

      collectHeading: "Escribe tu e-mail para activar el cupón",
      collectEmailPlaceholder: "Escribe tu e-mail",
      collectEmailSkip: "Omitir",
      collectSubmitBtn: "Acepta",

      noOfferError: "Lo lamentamos, ha ocurrido un error. Intenta refrescar tu navegador.",

      offerDollarOff: "{ offer.value | currency } Off",
      offerPercentOff: "{ offer.value }% Off",
      offerFreeShipping: "Envío gratuito",
      offerSessionOnly: "Válida sólo para esta sesión de compra.",

      walletHeading: "Tu portafolio - Elige una oferta por compra",
      walletCloseBtn: "Cerrar el portafolio",
      walletEmpty: "Aún no has recolectado ofertas.",
      applyToCartBtn: "Agrega al carrito",

      helpHeading: "Cómo trabaja",
      helpCloseBtn: "Cerrar Ayuda",
      helpText: [
        "# Reclama la oferta",
        "Para utilizar una oferta, reclámala haciendo clic en el botón dentro de la oferta. Veras luego la oferta acumulada dentro de tu portafolio con un nuevo botón para aplicar la oferta { wallet.helpAtcIconHtml } o como alternativa verás un código que puede ser utilizado durante el proceso de pago. Una vez añadida la oferta a tu portafolio podrás continuar navegando y utilizarla cuando estés listo.",
        "# Utilizar el portafolio",
        "Para ver tu portafolio, haz clic en el icono { wallet.helpIconHtml }. Verás una lista de ofertas que has recogido. Clickeando “Agrega al Carrito” verás  tu carrito y aplicará automáticamente el descuento. Utiliza cualquiera de las ofertas colectadas. Sólo puede ser utilizada una oferta por compra.",
        "# Consejo",
        "- Las ofertas pueden aparecer por única vez. Asegúrate de colectarlas cuando las veas.",
        "- Tu portafolio es válido sólo durante la visita actual, por lo tanto asegúrate de utilizarlas antes de abandonar el sitio.",
        "- El portafolio se puede ver y utilizar desde cualquier página del sitio entonces ábrelo cuando estés listo/a para comprar."
      ].join("\n"),

      monthsLong: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],

      mobileWalletHeader: "Ofertas"
    });
  };
});

fanplayr.define('services/offers/i18n/fr',[],function () {
  return function ( i18n ) {
    i18n.register("fr", {
      dateFormat: "%d. %B %Y",

      minimumPurchase: "A partir de { offer.minimumPurchase | currency } d'achats. ",
      noMinimumPurchase: "Sans minimum d'achat. ",
      expires: "Expire le { offer.expires | date }. ",
      conditionsApply: "Conditions d'application",
      addToWalletBtn: "Ajouter au porte-monnaie",

      conditionsHeading: "Conditions",

      collectHeading: "Entrer votre adresse email pour activer le code.",
      collectEmailPlaceholder: "Entrer votre email",
      collectEmailSkip: "Passer",
      collectSubmitBtn: "Valider",

      noOfferError: "Désolé une erreur s'est produite. Veuillez essayer de rafraichir votre navigateur.",

      offerDollarOff: "{ offer.value | currency } offert",
      offerPercentOff: "{ offer.value }% offert",
      offerFreeShipping: "Livraison offerte",
      offerSessionOnly: "Valable durant votre visite seulement.",

      walletHeading: "Votre porte monnaie - Choisissez une offre par achat",
      walletCloseBtn: "Fermer le porte monnaie",
      walletEmpty: "Vous n'avez pas collecté d'offre jusqu'à présent.",
      applyToCartBtn: "Ajouter au panier",

      helpHeading: "Comment ça marche",
      helpCloseBtn: "Fermer l'aide",
      helpText: [
        "# Bénéficier de l'offre",
        "Pour bénéficier d'une offre, sélectionnez-la en cliquant sur Ajouter au Porte-monnaie et en entrant votre adresse email ou vos identifiants Facebook. Vous verrez apparaître un code à utiliser au moment de régler vos achats. Ce code sera également ajouté à votre Porte-monnaie pour que vous puissiez continuer à naviguer et n'utilisiez l'offre que lorsque vous aurez fini.",
        "# Utiliser votre porte-monnaie",
        "Pour visualiser votre porte-monnaie, cliquez sur l'icône suivante { wallet.helpIconHtml }. Vous verrez apparaître la listes des offres que vous avez sélectionnées. Cliquez sur Appliquer au Panier pour voir appaître votre panier et les remises s'y appliquant automatiquement. Utilisez n'importe laquelle des offres que vous avez sélectionné. Une seule offre peut être utilisée par achat.",
        "# Conseils pratiques",
        "- Il se peut que les offres n'apparaissent qu'une seule fois. Assurez-vous de les sélectionner lorsqu'elles se présentent.",
        "- Dans la plupart des cas, votre porte-monnaie est valide uniquement pour la visite en cours, assurez-vous donc d'en profiter avant de quitter le site.",
        "- Les porte-monnaie virtuels peuvent être visualisés à partir de n'importe qu'elle page du site, continuez donc de naviguer et ouvrez votre porte-monnaie lorsque vous êtes prêt à acheter."
      ].join("\n"),

      monthsLong: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],

      mobileWalletHeader: "offre"
    });
  };
});

fanplayr.define('services/offers/i18n/he',[],function () {
  return function ( i18n ) {
    i18n.register("he", {
      dateFormat: "%e/%Y %B",

      minimumPurchase: "עלות קנייה החל מ { offer.minimumPurchase | currency } ומעלה. ",
      noMinimumPurchase: "אין מינימום עלות קנייה. ",
      expires: "תאריך תפוגה { offer.expires | date '%e/%Y %B' }. ",
      conditionsApply: "תנאים חלים",
      addToWalletBtn: "צרף לארנק",

      conditionsHeading: "תנאים כדקלמן",

      collectHeading: "נא הקלד את כתובת המייל שלך על מנת להוריד את הקופון",
      collectEmailPlaceholder: "הקלד את כתובת האימייל שלך",
      collectEmailSkip: "לְדַלֵג",
      collectSubmitBtn: "שלח",

      noOfferError: "אנו מתנצלים חלה שגיאה,אנא רענן את הדפדפן שלך",

      offerDollarOff: "{ offer.value | currency } הנחה",
      offerPercentOff: "{ offer.value }% הנחה",
      offerFreeShipping: "משלוח חינם",
      offerSessionOnly: "תקף רק לביקור הנוכחי. ",

      walletHeading: "הארנק שלך- בחר הטבה אחת בכל קנייה",
      walletCloseBtn: "סגור את הארנק",
      walletEmpty: "עדיין לא נבחרה שום הטבה.",
      applyToCartBtn: "הוסיף לסל",

      helpHeading: "איך זה עובד",
      helpCloseBtn: "סגור עזרה",
      helpText: [
        "# מימוש ההטבה",
        "על מנת לממש את ההטבה,הוסף את ההטבה לארנק לאחר התחברות למייל או לפייסבוק שלך.לאחר ההתחברות תקבל קוד אשר ישמש אותך בקופה. הקוד יחכה לך בארנק על מנת שתוכל להמשיך לגלוש כפי רצונך",
        "# שימוש בארנק",
        "על מנת לצפות בארנק שלך לחץ על האייקון שנראה כך { wallet.helpIconHtml }. לאחר מכן תוכל לראות את רשימת ההטבות שאספת. לחיצה על כפתור 'הוסף לסל' תציג בפנייך את הסל וההנחה תופעל באופן אוטומטי. בחר איזו הטבה מבין ההטבות שאספת,רק הטבה אחת תקפה פר קנייה.",
        "# עֵצָה",
        "- הטבות מוצעות רק פעם אחת. וודא שאתה בוחר בהטבה הרלוונטית ברגע שהיא מופיעה",
        "- ברוב המקרים הארנק שלך ישאר בתוקף רק בזמן הביקור הנוכחי באתר. לכן וודא שאתה מנצל את ההטבה לפני עזיבת האתר",
        "- גישה לארנק אפשרית מכל עמוד באתר. אז הרגש בנח לגלוש וחזור אל הארנק ברגע שתרצה לבצע רכישה"
      ].join("\n"),

      monthsLong: ["ינואר", "פבואר", "במרץ", "אפריל", "במאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],

      mobileWalletHeader: "הנחה"
    });
  };
});

fanplayr.define('services/offers/i18n/it',[],function () {
  return function ( i18n ) {
    i18n.register("it", {
      dateFormat: "%d %B %Y",

      minimumPurchase: "Acquista almeno { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "Nessuna spesa minima richiesta. ",
      expires: "Scade il { offer.expires | date }. ",
      conditionsApply: "Condizioni aggiuntive",
      addToWalletBtn: "Aggiungi al portafoglio",

      conditionsHeading: "Condizioni",

      collectHeading: "Inserisci il tuo indirizzo e-mail per attivare l'offerta",
      collectEmailPlaceholder: "Scrivi la tua e-mail",
      collectEmailSkip: "Omettere",
      collectSubmitBtn: "Accetta",

      noOfferError: "Siamo spiacenti, si è verificato un errore. Prova ad aggiornare il browser.",

      offerDollarOff: "Sconto di { offer.value | currency }",
      offerPercentOff: "Sconto del { offer.value }%",
      offerFreeShipping: "Spedizione Gratuita",
      offerSessionOnly: "Utilizzabile solo durante questa visita",

      walletHeading: "Il tuo portafoglio - Scegli un'offerta",
      walletCloseBtn: "Chiudi il portafoglio",
      walletEmpty: "Non hai ancora raccolte eventuali offerte.",
      applyToCartBtn: "Applica Coupon",

      helpHeading: "Come funziona",
      helpCloseBtn: "Chiudi Aiuto",
      helpText: [
        "# Richiedi l'offerta",
        "Durante la navigazione potrai ricevere una o più offerte. Ogni offerta sarà raccolta nel tuo portafoglio. Per utilizzare un'offerta, scorri il tuo portafoglio, scegli quella che più si addice al tuo acquisto e utilizzala cliccando sul bottone Applica Coupon o copiando il codice promozionale, se mostrato.",
        "# Usare il portafoglio",
        "Per vedere il tuo portafoglio clicca sull'icona { wallet.helpIconHtml }. Vedrai la lista delle offerte che hai raccolto. Non preoccuparti se l'ultima offerta sembra rimpiazzare una precedentemente visualizzata a cui eri interessato: sarà sempre presente nel tuo portafoglio e potrai utilizzarla per il tuo ordine.",
        "# Consigli",
        "- Se applichi l'offerta sbagliata o se per qualunque motivo vuoi cambiare l'offerta che hai precedentemente applicato potrebbe essere necessario rimuovere dal carrello l'offerta precedente prima di poter inserire la nuova offerta.",
        "- ll tuo portafoglio offerte è valido solo per la visita corrente, assicurati di sfruttare l'offerta prima di lasciare il sito. Il portafoglio può essere visualizzato in qualunque pagina del sito, quindi naviga liberamente ed utilizza l'offerta quando sei pronto a completare il tuo acquisto."
      ].join("\n"),

      monthsLong: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],

      mobileWalletHeader: "Offerte"
    });
  };
});

fanplayr.define('services/offers/i18n/ja',[],function () {
  return function ( i18n ) {
    i18n.register("ja", {
      dateFormat: "%b %e, %Y",

      minimumPurchase: "{ offer.minimumPurchase | currency }以上のご購入にて使用できます。",
      noMinimumPurchase: "最小ご注文金額なし。",
      expires: "{ offer.expires | date } まで。",
      conditionsApply: "ご利用条件",
      addToWalletBtn: "ウォレットに追加",

      conditionsHeading: "ご利用条件",

      collectHeading: "クーポンを使用するEメール·アドレスを入力",
      collectEmailPlaceholder: "Eメールアドレス",
      collectEmailSkip: "スキップ",
      collectSubmitBtn: "送信",

      noOfferError: "申し訳ありませんが、エラーが発生しました。ブラウザをリフレッシュしてみてください。",

      offerDollarOff: "{ offer.value | currency }オフ",
      offerPercentOff: "{ offer.value }%オフ",
      offerFreeShipping: "送料無料",
      offerSessionOnly: "今回のご訪問に限り、ご使用できます。",

      walletHeading: "ご利用条件",
      walletCloseBtn: "ウォレットを閉じる",
      walletEmpty: "あなたはまだオファーを収集していない。",
      applyToCartBtn: "クーポンを利用する",

      helpHeading: "使い方",
      helpCloseBtn: "ヘルプを閉じる",
      helpText: [
        "# 特典を集める",
        "ウォレットに追加をクリックしてEメールアドレスを入力するかFacebookアカウントに接続してください。特典をご使用になるためのコードが表示されます。特典はウォレットに記憶されますので引き続きWebの閲覧していただき、準備ができから特典をご使用ください。",
        "# ウォレットを使う",
        "ウォレットの内容を見るためには、このアイコン{ wallet.helpIconHtml }をクリックしてください。収集した特典が表示されます。”特典を使う”をクリックするとカート、申込ページ等が表示され、特典コードをお使いになれます。このとき集めた特典のうち、一つだけ使えます。",
        "# ヒント",
        "- 特典を１回しか表示しない場合があります。チャンスを逃さないよう、すぐにウォレットに追加してください。",
        "- ほとんどの場合、ウォレットはこのウェブサイト滞在中だけ有効です。このサイトを離れる前に特典をご利用ください。",
        "- ウォレットはこのウェブサイトのどのページからも開くことができますので、充分にウィブサイトを閲覧し、準備ができましたらウォレットを開いてください。"
      ].join("\n"),

      mobileWalletHeader: "特典"
    });
  };
});

fanplayr.define('services/offers/i18n/ko',[],function () {
  return function ( i18n ) {
    i18n.register("ko", {
      dateFormat: "%Y년 %m월 %e일",

      minimumPurchase: "{ offer.minimumPurchase | currency } 이상 구매. ",
      noMinimumPurchase: "최소 구매가 필요하지 않습니다. ",
      expires: "{ offer.expires | date }만료. ",
      conditionsApply: "조건이 적용됩니다",
      addToWalletBtn: "지갑에 추가",

      conditionsHeading: "약관",

      collectHeading: "쿠폰적용시 이메일을 입력",
      collectEmailPlaceholder: "이메일을 입력",
      collectEmailSkip: "연기",
      collectSubmitBtn: "적용",

      noOfferError: "죄송합니다, 오류가 발생했습니다. 브라우저를 새로 고침 해보세요.",

      offerDollarOff: "{ offer.value | currency } 할인",
      offerPercentOff: "{ offer.value }% 할인",
      offerFreeShipping: "무료 배송",
      offerSessionOnly: "지금 방문 이용가능.",

      walletHeading: "지갑 – 구매 당 1 이벤트를 선택",
      walletCloseBtn: "지갑 닫기",
      walletEmpty: "아직 쿠폰을 수집하지 않았습니다.",
      applyToCartBtn: "장바구니에 적용",

      helpHeading: "이용 방법",
      helpCloseBtn: "도움말 닫기",
      helpText: [
        "# 할인을 이용하는 방법",
        "할인 혜택을 사용하려면, 지갑에 추가하고 전자 메일 주소를 사용 클릭합니다. 체크 아웃시에 적용 할 수있는 코드를 볼 수 있습니다. 검색을 하고 체크아웃 시에 할인을 사용할 수 있도록 쿠폰이 지갑에 추가됩니다.",
        "# 지갑 사용하기",
        "당신의 지갑을 보려면, 모양 아이콘을 클릭합니다 { wallet.helpIconHtml }. 쿠폰 수집 한 목록이 표시됩니다. 할인을 적용 자동으로 카트를 표시합니다 장바구니에 적용을 클릭. 수집 한 할인 중 하나를 사용하십시오. 구매당 쿠폰 하나만 사용할 수 있습니다.",
        "# 팁",
        "- 할인은 한 번만 나타날 수 있습니다. 쿠폰을 꼭 제시하십시오.",
        "- 대부분의 경우에, 쿠폰은 현재 방문에시에만 유효하오니 창을 닫기전에 꼭 사용하시기 바랍니다.",
        "- 사이트 모든 페이지에서 쿠폰지갑을 열어보실 수 있습니다. 이 창을 닫아도 사용시 무관하오니 체크아웃을 원하실때 확인해주십시오."
      ].join("\n"),

      mobileWalletHeader: "할인"
    });
  };
});

fanplayr.define('services/offers/i18n/nl',[],function () {
  return function ( i18n ) {
    i18n.register("nl", {
      dateFormat: "%d-%m-%Y",

      minimumPurchase: "Bij aankoop vanaf { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "Geen minimum aankoopbedrag. ",
      expires: "Geldig t/m { offer.expires | date }. ",
      conditionsApply: "Actievoorwaarden",
      addToWalletBtn: "Toevoegen aan portemonnee",

      conditionsHeading: "Voorwaarden",

      collectHeading: "Vul uw e-mailadres in om deze coupon te activeren",
      collectEmailPlaceholder: "Vul uw e-mailadres in",
      collectEmailSkip: "Weglaten",
      collectSubmitBtn: "Bevestigen",

      noOfferError: "Excuses, er is een fout opgetreden. Probeer uw browser te herladen.",

      offerDollarOff: "{ offer.value | currency } korting",
      offerPercentOff: "{ offer.value }% korting",
      offerFreeShipping: "Gratis verzending",
      // offerSessionOnly: "Alleen geldig tijdens dit bezoek.",
      offerSessionOnly: "",

      // walletHeading: "Uw portemonnee - Kies één aanbieding per bestelling",
      walletHeading: "<b>Uw korting — alleen geldig tijdens dit bezoek!</b> (maximaal één aanbieding per bestelling)",
      walletCloseBtn: "Sluit portemonnee",
      walletEmpty: "U hebt nog geen korting verzilverd.",
      applyToCartBtn: "Korting verzilveren",

      helpHeading: "Hoe werkt het",
      helpCloseBtn: "Help Sluiten",
      helpText: [
        "# De korting verzilveren",
        "Om een korting te verzilveren, klik je op \"Korting activeren\". De kortingscode zal worden bewaard zodat je verder kunt winkelen en de korting kunt gebruiken wanneer je gaat afrekenen.",
        "# Gebruik van de korting(en)",
        "Om je bewaarde korting(en) te zien, klik op het icoon dat er zo { wallet.helpIconHtml } uit ziet. Je ziet dan een lijst met alle verzamelde aanbiedingen. Een klik op \"code verzilveren\" past de korting automatisch toe op je bestelling (als je voldoet aan de voorwaarden). Maximaal één korting te gebruiken per bestelling en alleen geldig tijdens dit bezoek.",
        "# Tips",
        "- Aanbiedingen kunnen soms slechts één keer verschijnen. Zorg ervoor dat je de korting verzilverd wanneer deze wordt getoond.",
        "- In de meeste gevallen is een korting alleen geldig tijdens dat bezoek. Het is dus raadzaam de aanbieding te verzilveren voordat je de webshop verlaat.",
        "- De korting kan worden bekeken en gebruikt vanaf elke pagina op de site. Winkel gerust verder en verzilver je korting wanneer je klaar bent om af te rekenen."
      ].join("\n"),

      monthsLong: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],

      mobileWalletHeader: "Korting"
    });
  };
});

fanplayr.define('services/offers/i18n/pt',[],function () {
  return function ( i18n ) {
    i18n.register("pt", {
      dateFormat: "%d de %B, %Y",

      minimumPurchase: "Compra de { offer.minimumPurchase | currency } ou mais. ",
      noMinimumPurchase: "Sem compra mínima exigida. ",
      expires: "Expira em { offer.expires | date }. ",
      conditionsApply: "Condições Aplicáveis",
      addToWalletBtn: "Adicionar a carteira",

      conditionsHeading: "Condições",

      collectHeading: "Digite seu endereço de e-mail para ativar este cupom",
      collectEmailPlaceholder: "Digite seu e-mail",
      collectEmailSkip: "Omitir",
      collectSubmitBtn: "Enviar",

      noOfferError: "Desculpe, ocorreu um erro. Por favor, tente recarregar este site.",

      offerDollarOff: "{ offer.value | currency } de desconto",
      offerPercentOff: "{ offer.value } % de desconto",
      offerFreeShipping: "Frete grátis",
      offerSessionOnly: "Resgatáveis ​​somente durante esta visita.",

      walletHeading: "Sua carteira - Escolha uma oferta por compra",
      walletCloseBtn: "Fechar carteira",
      walletEmpty: "Voce ainda nao coeltou nenhuma oferta.",
      applyToCartBtn: "Aplicar ao carrinho",

      helpHeading: "Como Funciona",
      helpCloseBtn: "Fechar Ajuda",
      helpText: [
        "# Usando a Oferta",
        "Para usar uma oferta , reivindicá-la clicando em Adicionar Para Carteira e use seu endereço de e-mail ou conta no Facebook. Você vai ver um código que pode ser resgatado durante o checkout . Ele também será adicionado à sua carteira para que possa continuar a navegar e utilizar a oferta , quando estiver pronto.",
        "# Usando a carteira",
        "Para ver a sua carteira, clique no ícone que se parece com isso { wallet.helpIconHtml }. Você verá a lista de ofertas que você coletou . Clicar em Aplicar ao carrinho exibirá seu carrinho e automaticamente aplicar o desconto . Use qualquer uma das ofertas que você coletou . Apenas uma oferta pode ser utilizado por compra.",
        "# Dicas",
        "- Ofertas podem aparecer apenas uma vez . Lembre-se de usar elas quando elas aparecerem.",
        "- Na maioria dos casos, sua carteira é válida apenas para a visita atual, por isso lembre-se de usá-la antes de deixar o site.",
        "- Carteiras pode ser vistas e usadas a partir de qualquer página do site, por isso navegar para onde quiser e abra a sua carteira quando você estiver pronto para comprar."
      ].join("\n"),

      monthsLong: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "septembro", "outubro", "novembro", "dezembro"],

      mobileWalletHeader: "Ofertas"
    });
  };
});

fanplayr.define('services/offers/i18n/ru',[],function () {
  return function ( i18n ) {
    i18n.register("ru", {
      dateFormat: "%de %B %Y",

      minimumPurchase: "Заказ на сумму от { offer.minimumPurchase | currency }. ",
      noMinimumPurchase: "Без минимальной суммы. ",
      expires: "Действует до { offer.expires | date }. ",
      conditionsApply: "Условия для получения",
      addToWalletBtn: "Добавить в копилку",

      conditionsHeading: "Условия",

      collectHeading: "Укажите Ваш email для активации купона.",
      collectEmailPlaceholder: "Адрес электронной почты",
      collectEmailSkip: "пропускать",
      collectSubmitBtn: "Подтвердить",

      noOfferError: "Произошла ошибка. Попробуйте обновить страницу.",

      offerDollarOff: "Скидка { offer.value | currency }",
      offerPercentOff: "Скидка { offer.value }%",
      offerFreeShipping: "Бесплатная доставка",
      offerSessionOnly: "Действительно только сейчас! Не уходите с сайта.",

      walletHeading: "Ваша копилка — Выберите один из купонов",
      walletCloseBtn: "Закрыть копилку",
      walletEmpty: "В вашей копилке пока нет купонов",
      applyToCartBtn: "Использовать",

      helpHeading: "Как это работает",
      helpCloseBtn: "Закрыть",
      helpText: [
        "# Использование купонов",
        "Чтобы использовать купон, добавьте его в копилку, нажав на кнопку «Добавить в копилку» и указав адрес электронной почты (email) или подключив аккаунт Facebook. Далее вы увидите код, который можно использовать во время заказа. Код купона также будет сохранен в вашей копилке, вы можете продолжить просматривайть сайт и использовать его позже.",
        "# Использование копилки",
        "Чтобы открыть копилку, нажмите на икноку { wallet.helpIconHtml }. Вы увидите список купонов, которые вы в нее добавили. Нажав кнопку «Использовать», вы примените купон к текущему заказу. Вы можете использовать любой купон, из тех, что вы добавили в копилку. На один заказ может быть использован только один купон.",
        "# Советы",
        "- Некоторые купоны появляются только по одному разу. Не забывайте добавлять их в корзину, когда видите.",
        "- Во многих случаях купоны в копилке будут доступны только в течение вашего текущего визита. Поэтому убедитесь, что не хотите ими воспользоваться, прежде чем уйти с сайта.",
        "- Вы можете открыть и использовать копилку на любой странице сайта. Поэтому спокойно просматривайте сайт и открывайте копилку, когда посчитаете необходимым."
      ].join("\n"),

      monthsLong: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"],

      mobileWalletHeader: "купоны"
    });
  };
});

fanplayr.define('services/offers/i18n/se',[],function () {
  return function ( i18n ) {
    i18n.register("se", {
      dateFormat: "%de %B %Y",

      minimumPurchase: "Köp för { offer.minimumPurchase | currency } eller mer. ",
      noMinimumPurchase: "Inget krav på minsta ordervärde. ",
      expires: "Giltig till och med { offer.expires | date }. ",
      conditionsApply: "Villkor gäller",
      addToWalletBtn: "Lägg till i plånbok",

      conditionsHeading: "Villkor",

      collectHeading: "Skriv in din e-post adress för att aktivera den här kupongen",
      collectEmailPlaceholder: "Skriv in din e-post",
      collectEmailSkip: "Utelämna",
      collectSubmitBtn: "Godkän",

      noOfferError: "Ursäkta, det blev något fel. Vänligen försök att uppdatera din webbläsare.",

      offerDollarOff: "{ offer.value | currency } Rabatt",
      offerPercentOff: "{ offer.value }% Rabatt",
      offerFreeShipping: "Gratis frakt",
      offerSessionOnly: "Kan endast lösas in vid detta besök.",

      walletHeading: "Din Plånbok - välj ett erbjudande per köp",
      walletCloseBtn: "Stäng plånbok",
      walletEmpty: "Du har inte tagit del av några erbjudanden än.",
      applyToCartBtn: "Använd i varukorg",

      helpHeading: "Hur det fungerar",
      helpCloseBtn: "Stäng Hjälp",
      helpText: [
        "# Ta del av erbjudandet",
        "För att använda ett erbjudande, ta del av det genom att lägga till det i plånboken och använd din email adress eller ditt Facebook-konto. Du kommer då se en kod som du kan lösa in när du checkar ut. Den kommer också läggas till i din plånbok så att du kan fortsätta att bläddra och använda erbjudandet när du är redo.",
        "# Användande av plånboken",
        "För att se din plånbok, klicka på ikonen som ser ut så här { wallet.helpIconHtml }. Du kommer se en lista av erbjudanden som du har sparat. Klicka på 'använd i varukorg' så kommer du se din varukorg och automatiskt ta del av rabatten. Använd något av de erbjudanden som du har sparat. Bara ett erbjudande kan användas per köp.",
        "# Tips",
        "- Erbjudanden kommer bara att visas en gång. Säkerställ att du sparar de när de presenteras.",
        "- Vid de flesta tillfällen är din plånbok giltig för ditt aktuella besök så säkerställ att du tar del av erbjudanden innan du lämnar sidan.",
        "- Plånböcker kan visas och användas från varje sida på webbplatsen så bläddra bort och öppna plånboken när du är redo att köpa."
      ].join("\n"),

      monthsLong: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],

      mobileWalletHeader: "Erbjudande"
    });
  };
});

fanplayr.define('services/offers/i18n/tr',[],function () {
  return function ( i18n ) {
    i18n.register("tr", {
      dateFormat: "%d %B %Y",

      minimumPurchase: "{ offer.minimumPurchase | currency } veya daha fazla satın alın. ",
      noMinimumPurchase: "Hiçbir minimum satın alma gereklidir. ",
      expires: "Teklif { offer.expires | date } sona eriyor. ",
      conditionsApply: "Koşullar uygulayın",
      addToWalletBtn: "Cüzdan ekle",

      conditionsHeading: "koşullar",

      collectHeading: "Bu kupon etkinleştirmek için e-posta adresinizi girin",
      collectEmailPlaceholder: "E-postanızı girin",
      collectEmailSkip: "Atlamak",
      collectSubmitBtn: "teslim etmek",

      noOfferError: "Özür dileriz, bir hata oluştu. Tarayıcınız ferahlatıcı deneyin.",

      offerDollarOff: "{ offer.value | currency } Off",
      offerPercentOff: "{ offer.value }% Off",
      offerFreeShipping: "Ücretsiz Kargo",
      offerSessionOnly: "Sadece bu ziyaret sırasında çevrilemez.",

      walletHeading: "Kişisel Cüzdan - bir teklif seçin",
      walletCloseBtn: "Cerrar el portafolio",
      walletEmpty: "Henüz herhangi bir teklifi toplanan değil.",
      applyToCartBtn: "Sepete Uygula",

      helpHeading: "Nasıl Çalışır",
      helpCloseBtn: "Kapat Sayfa",
      helpText: [
        "# Teklif alma",
        "Tıklatın 'Cüzdan ekle' butonuna tıklayarak pazarlık almak. E-posta adresinizi veya Facebook kullanın. Ödeme sırasında kodu kullanın. Daha sonra kullanabilirsiniz böylece teklif cüzdan eklenecektir.",
        "# Cüzdan kullanma",
        "Tıklayın { wallet.helpIconHtml }. toplanan olduğunuz pazarlık bir listesini göreceksiniz. tıklayın 'Sepete Uygula' ve sepetinize otomatik olarak indirim uygulanır. Sadece bir teklif satın alma başına kullanılabilir.",
        "# Ipucu",
        "- Teklifler sadece bir kez görülebilir. Sunulduğunda onları toplamak için emin olun.",
        "- Bazen cüzdan yalnızca geçerli ziyaret için geçerlidir. Dükkan ayrılmadan önce cüzdan kullandığınızdan emin olun."
      ].join("\n"),

      monthsLong: ["ocak", "şubat", "mart", "nisan", "mayıs", "haziran", "temmuz", "ağustos", "eylül", "ekim", "kasım", "aralık"],

      mobileWalletHeader: "Teklifler"
    });
  };
});

fanplayr.define('services/offers/i18n',[
  "platform/utils",
  "platform/log",
  "platform/emitter",
  "platform",
   // languages
  "services/offers/i18n/ar",
  "services/offers/i18n/de",
  "services/offers/i18n/en",
  "services/offers/i18n/es",
  "services/offers/i18n/fr",
  "services/offers/i18n/he",
  "services/offers/i18n/it",
  "services/offers/i18n/ja",
  "services/offers/i18n/ko",
  "services/offers/i18n/nl",
  "services/offers/i18n/pt",
  "services/offers/i18n/ru",
  "services/offers/i18n/se",
  "services/offers/i18n/tr"
], function ( _, log, Emitter, platform ) {

  var LANGUAGE_ARG_INDEX = 4;

  function i18n ( key ) {
    var current = i18n.current,
      en = i18n.defs.en,
      override = i18n.override;

    if ( override && typeof override[key] !== "undefined" ) {
      return override[key];
    }

    if ( current && current.hasOwnProperty(key) ) {
      return current[key];
    }

    if ( en && en.hasOwnProperty(key) ) {
      return en[key];
    }
  }

  Emitter.mixin(i18n);

  i18n.defs = {};
  i18n.override = {};
  i18n.configOverrides = {};

  i18n.register = function ( name, def ) {
    i18n.defs[name] = def;
    def.$name = name;
    // log("register '" + name + "'");
  };

  i18n.use = function ( name ) {
    i18n.code = name;
    i18n.current = _.merge({}, i18n.defs[name], i18n.override, i18n.configOverrides[name] || {});
    i18n.emit("change", [i18n.current]);
  };

  for ( var i = LANGUAGE_ARG_INDEX; i < arguments.length; i++ ) {
    arguments[i](i18n);
  }

  i18n.register('el', _.clone(i18n.defs.en));
  i18n.register('bg', _.clone(i18n.defs.en));
  i18n.register('pl', _.clone(i18n.defs.en));
  i18n.register('ro', _.clone(i18n.defs.en));

  // Captures the "config" object in the most recent tracking
  // response and filters it for any overriding localization
  // strings with keys in the form:
  //   "offerWidget.<language_code>.<i18n_key>"
  platform.on("track", { init: true }, function ( res ) {
    var config = res && res.config;
    var overrides = {};
    if ( _.isPlainObject(config) ) {
      var pattern = /^offerWidget\.(\w{2})\.(.+)/;
      _.each(config, function ( value, key ) {
        if ( typeof key === "string" ) {
          var match = key.match(pattern);
          if ( match ) {
            var code = match[1];
            key = match[2];
            var lang = overrides[code];
            if ( !lang ) {
              lang = overrides[code] = {};
            }
            lang[key] = value;
          }
        }
      });
    }
    i18n.configOverrides = overrides;
  });

  return i18n;
});

fanplayr.define('services/offers/depOffers',[
  "platform/utils",
  "platform/jquery",
  "platform/log",
  "platform/capabilities"
], function ( _, $, log, capabilities ) {
  log = log.create("offers:deputization");

  var api = {};

  /**
  * Map of temp codes to their state. This is persisted in the offer stash.
  *
  * There are two possible states of a temp code:
  *   - Deputized: The temp code will map to `true`.
  *   - Undeputized: The temp code will map to a string, the real code.
  */
  var depState = {};

  /**
  * Map of temp codes that are currently being deputized.
  * This is used to prevent doubling up of work from multiple
  * calls to deputize() with the same input on the current page.
  */
  var inProgress = {};

  var offerService, stash, deputizeUrl;
  api.init = function ( options ) {
    offerService = options.service;
    stash = options.stash;
    deputizeUrl = options.deputizeUrl;

    loadState();
  };

  /**
  * Attempts to deputize any pending temp codes.
  * Should be called by the offer service before any calls to deputize().
  */
  api.processPending = function () {
    _.each(depState, function ( realCode, tempCode ) {
      if ( typeof realCode === "string" ) {
        // log("deputize pending: ", tempCode);
        deputize(realCode, tempCode);
      }
    });
  };

  api.deputize = function ( info ) {
    deputize(info.real, info.temp);
  };

  /**
  * Deputizes
  */
  function deputize ( realCode, tempCode ) {
    if ( tempCode ) {
      var state = depState[tempCode];
      if ( state === true ) {
        // Already deputized.
        // log("already deputized: ", tempCode);
        return;
      }

      if ( inProgress[tempCode] ) {
        // Deputization already in progress.
        // log("already deputizing: ", tempCode);
        return;
      }

      // Mark as needing to be deputized.
      // log("deputizing: " + tempCode + " --> " + realCode);
      depState[tempCode] = realCode;
      saveState();

      // Mark as in progress.
      inProgress[tempCode] = true;

      var prevented = false;

      // a = actual, d = deputized.
      var url = deputizeUrl && deputizeUrl.replace("%a", encodeURIComponent(realCode)).replace("%d", encodeURIComponent(tempCode));

      // Handle `deputizeOffer` callback.
      var deputizeOffer = capabilities.deputizeOffer;
      if ( _.isFunction(deputizeOffer) ) {
        (function () {
          var isAsync = false;

          var doneFn = function ( result ) {
            if ( result !== false ) {
              depState[tempCode] = true;
              saveState();
            }
          };

          var event = {
            type: "offer:deputize",
            code: realCode,
            tempCode: tempCode,
            url: url,
            originalUrl: deputizeUrl,
            async: function () {
              isAsync = true;
              return doneFn;
            }
          };

          var result = deputizeOffer(event);
          if (result && typeof result.then === "function") {
            // Modern: handler returned a Promise
            result.then(
              function () { doneFn(); },
              function () { doneFn(false); }
            );
          } else if (result !== false && !isAsync) {
            // Legacy: synchronous or doneFn-based async
            doneFn();
          }
        }());
        return;
      }

      var event = {
        offer: {
          code: realCode,
          tempCode: tempCode
        },
        url: url,
        originalUrl: deputizeUrl,
        preventDefault: function () {
          prevented = true;
        }
      };

      // stash.set("d." + tempCode, realCode, "2h, sk");
      // stash.save();

      offerService.emit("deputize", [event], function () {
        url = event.url;

        if ( !prevented && url ) {
          // A bang/exclaimation mark (!) at the start of the url signifies
          // that the iframe should not be removed, due to JS being loaded
          // on the page and possibly being reloaded (Tarwin does crazy stuff to make shit work).
          var keepIframe = (url.charAt(0) === "!");
          if ( keepIframe ) {
            url = url.substr(1);
          }

          // Use an iframe to invoke the api to ensure cookies are sent
          //  and the current session persists.
          var $iframe = $("<iframe/>");
          $iframe.hide();

          // var startTime = _.now();

          $iframe.on("load", function( event ) {
            // Remove from pending queue.
            // log("finished deputizing: ", tempCode, "took: ", (_.now() - startTime), "ms");
            depState[tempCode] = true;
            saveState();

            if ( !keepIframe ) {
              setTimeout(function () {
                $iframe.remove();
              }, 1000);
            }
          });

          $iframe.attr("src", url).appendTo("body");
        }
      });
    }
  }

  function loadState () {
    depState = stash.get("depState") || {};
  }

  function saveState () {
    stash.set("depState", depState, "sk");
    stash.save();
  }

  return api;
});

fanplayr.define('services/offers/sessionOffers',[
  "platform/utils",
  "platform/jquery",
  "platform/log",
  "platform/capabilities"
], function ( _, $, log, capabilities ) {
  var api = {};

  var codeStates = {};
  var inProgress = {};

  var offerService, stash, sessionOfferUrl;
  api.init = function ( options ) {
    offerService = options.service;
    stash = options.stash;
    sessionOfferUrl = options.sessionOfferUrl;
    loadState();
  };

  api.processPending = function () {
    _.each(codeStates, function ( state, code ) {
      if ( state === "pending" ) {
        api.process(code);
      }
    });
  };

  api.processAll = function () {
    _.each(codeStates, function ( state, code ) {
      if ( state === "complete" ) {
        codeStates[code] = "pending";
      }
    });
    saveState();
    api.processPending();
  };

  api.process = function ( code, processDoneCb ) {
    var invokeProcessCb = function () {
      if ( processDoneCb ) {
        processDoneCb();
        processDoneCb = null;
      }
    };

    var state = codeStates[code];
    if ( state === "complete" || inProgress[code] ) {
      invokeProcessCb();
      return;
    }
    codeStates[code] = "pending";
    inProgress[code] = true;
    saveState();

    var url = sessionOfferUrl && sessionOfferUrl.replace(/%c/g, encodeURIComponent(code));

    // Handle `sessionOffer` callback.
    var sessionOfferCb = capabilities.sessionOffer;
    if (_.isFunction(sessionOfferCb)) {
      (function () {
        var isAsync = false;

        var doneFn = function (result) {
          if (result !== false) {
            codeStates[code] = "complete";
            saveState();
          }
          invokeProcessCb();
        };

        var event = {
          type: "offer:session",
          code: code,
          url: url,
          originalUrl: sessionOfferUrl,
          async: function () {
            isAsync = true;
            return doneFn;
          }
        };

        var result = sessionOfferCb(event);
        if (result && typeof result.then === "function") {
          // Modern: handler returned a Promise
          result.then(
            function () { doneFn(); },
            function () { doneFn(false); }
          );
        } else if (result !== false && !isAsync) {
          // Legacy: synchronous or doneFn-based async
          doneFn();
        }
      }());
      return;
    }

    if ( url ) {
      invokeUrl(url, function () {
        codeStates[code] = "complete";
        saveState();
        invokeProcessCb();
      });
      return;
    }

    // There's nothing to do so invoke callback immediately.
    invokeProcessCb();
  };

  function invokeUrl ( url, callback ) {
    var parsedUrl = _.parseUrl(url);
    if ( parsedUrl.hostname === window.location.hostname ) {
      $.ajax({
        url: url,
        dataType: "get",
        complete: callback
      });
    } else {
      // Use an iframe for cross-domain requests and remove it a second
      // after it loads.
      var $iframe = $("<iframe/>");
      $iframe.hide();
      $iframe.on("load", function( event ) {
        callback();
        setTimeout(function () {
          $iframe.remove();
        }, 1000);
      });
      $iframe.attr("src", url).appendTo("body");
    }
  }

  function loadState () {
    codeStates = stash.get("sessionOffers") || {};
  }

  function saveState () {
    stash.set("sessionOffers", codeStates, "sk");
    stash.save();
  }

  return api;
});

fanplayr.define('services/offers/offers',[
  "platform",
  "platform/config",
  "platform/utils",
  "platform/jquery",
  "platform/log",
  "platform/stash",
  "platform/loader",
  "platform/legacy",
  "platform/emitter",
  "platform/capabilities",
  "services/offers/i18n",
  "services/offers/depOffers",
  "services/offers/sessionOffers"
], function ( platform, Config, _, $, log, Stash, Loader, Legacy, Emitter, Capabilities, i18n, depOffers, sessionOffers ) {
  log = log.create("offers");

  var stash = Stash.create({
    name: "fanplayr:offers",
    scope: "domain",
    defaultSetOptions: {
      essential: true
    }
  });

  var service = Emitter.mixin({
    stash: stash,
    i18n: i18n,
    Offer: Offer
  });

  var isPreview;

  var widget = service.widget = {};
  var offer  = service.offer  = {};
  var wallet = service.wallet = {};

  var embedData = Legacy.getEmbedData();
  var applyToCartUrl = embedData && embedData.applyToCartUrl || Capabilities.applyToCartUrl;
  var deputizeUrl = embedData && embedData.deputizeUrl || Capabilities.deputizeUrl;
  var sessionOfferUrl = embedData && embedData.sessionOfferUrl || Capabilities.sessionOfferUrl;
  var trackRes;

  stash.load(function () {
    depOffers.init({
      service: service,
      stash: stash,
      deputizeUrl: deputizeUrl
    });

    sessionOffers.init({
      service: service,
      stash: stash,
      sessionOfferUrl: sessionOfferUrl
    });

    platform.on("track", { init: true }, function ( visit ) {
      trackRes = visit;

      depOffers.processPending();
      sessionOffers.processPending();
    });

    // For legacy offer & exit-intent widgets only.
    platform.on("offer", { init: true }, function ( offerRes ) {
      updateModel(trackRes, offerRes);
    });

    platform.on("newBrowserSession", { init: true }, function () {
      sessionOffers.processAll();
    });

    handleExitIntent();

    platform.emit("offer:api", [service]);
  });

  service.applyOffer = function ( offer, callback ) {
    var event = {
      type: "offer:apply",
      prevented: false,
      code: offer.code,
      tempCode: offer.tempCode,
      applyToCartUrl: offer.applyToCartUrl,
      preventDefault: function () {
        event.prevented = true;
      }
    };

    if ( typeof Capabilities.applyToCart === "function" ) {
      Capabilities.applyToCart(event);
    } else {
      platform.emit("offer:apply", [event], function () {
        if ( callback ) {
          callback(event);
        }

        if ( !event.prevented && event.applyToCartUrl ) {
          window.top.location = event.applyToCartUrl;
        }
      });
    }
  };

  service.autoCollect = function ( callback ) {
    service.submitEmail("Not Collected", callback);
  };

  // For legacy offer & exit-intent widgets only.
  service.submitEmail = function ( email, callback ) {
    service.emit("loading");

    stash.data.email = email;
    stash.save();

    var offer = service.offer;

    var alreadyCollected;
    _.each(wallet.offers, function ( other ) {
      if ( other.id === offer.id ) {
        alreadyCollected = true;
      }
    });

    if ( alreadyCollected ) {
      offer.stash.collected = 1;
      stash.save();

      service.emit("loaded");
      if ( callback ) {
        callback(null);
      }
      return;
    }

    service.requestCode(offer, email, function ( err, data ) {
      if ( data ) {
        offer.stash.collected = 1;
        stash.save();

        var collectedOffer = {
          text:            offer.text,
          minimumPurchase: offer.minimumPurchase,
          expires:         offer.expires,
          conditions:      offer.conditions,
          code:            data.promoCode,
          tempCode:        data.tempCode
        };

        authorizeOffer(collectedOffer);

        initOffer(collectedOffer);
        service.emit("collect", [collectedOffer]);
      }

      service.emit("loaded");
      if ( callback ) {
        callback(null);
      }
    });
  };

  service.requestCode = function ( offer, email, callback ) {
    if ( isPreview ) {
      return callback(null, {
        promoCode: "PREVIEW",
        temoCode: null
      });
    }

    $.ajax({
      url: "//" + Config.sessionEndpoint + "/external.Genius/",
      data: {
        a: "code",
        campaign: Config.campaignKey,
        session: Config.sessionKey,
        user: Config.userKey,
        offer: offer.id,
        email: email,
        fb_id: 0
      },
      dataType: "jsonp",
      success: function ( resp ) {
        callback(null, resp);
      },
      error: function () {
        log("requestCode error");
        callback(true);
      }
    });
  };

  // Delete stash information for offers that are revoked.
  platform.on("offers:revoke", { init: true }, function ( data ) {
    _.each(data.ids, function ( id ) {
      stash.del("o." + id);
    });
    stash.save();
  });

  // For legacy offer & exit-intent widgets only.
  function updateModel ( trackRes, offerRes ) {
    widget.colors = {
      background: offerRes.color1,
      text:       offerRes.color2,
      button:     offerRes.color3,
      buttonText: offerRes.color4
    };

    widget.innerCss = trackRes.innerCss;
    widget.outerCss = trackRes.outerCss;

    isPreview = widget.isPreview = offerRes.preview;

    widget.extraCssClasses = offerRes.classes || "";

    widget.language = offerRes.language || "en";
    widget.emailCollectionMode = normalizeEmailCollectionMode(offerRes.email_collection_mode);

    service.siteCssUrl = trackRes.site_css_url;
    service.widgetCssUrl = offerRes.customCssUrl;

    var i18nOverride = offerRes.language_override_data;
    if ( i18nOverride ) {
      i18n.override.addToWalletBtn = i18nOverride.activate_btn;
    }

    i18n.use(widget.language);

    i18n.currencySymbol = offerRes.currency_symbol;

    _.merge(offer, {
      id:               offerRes.incentive_id,
      text:             offerRes.reward,
      message:          offerRes.message,
      minimumPurchase:  offerRes.minimum_purchase > 0 ? offerRes.minimum_purchase : 0,
      expires:          offerRes.expiry_timestamp,
      imageUrl:         offerRes.image && offerRes.image.url,
      conditions:       offerRes.conditions,
      hasAutoCollected: trackRes.has_auto_collected_offer,
      delay:            (trackRes.offer_delay || 0) * 1000
    });

    var offerLink = getOfferLinkObject(offerRes.link_text, offerRes.link_url);
    if ( offerLink ) {
      offer.link = offerLink;
    } else {
      delete offer.link;
    }

    offer.stash = stash.get("o." + offer.id) || {};

    offer.hasPresented = !!offer.stash.presented;
    offer.hasCollected = !!offer.stash.collected;

    var trackParams = {};
    trackRes.widget_url.replace(/([^?&=]+)=([^&]+)/g, function ( line, key, value ) {
      trackParams[key] = value;
    });

    if ( offer.hasAutoCollected ) {
      offer.code = trackParams.ac_promo_code;
      offer.tempCode = trackParams.ac_temp_code;
      authorizeOffer(offer);
    }

    offer.stash.presented = 1;
    if ( offer.hasAutoCollected ) {
      offer.stash.collected = 1;
    }

    stash.set("o." + offer.id, offer.stash, "2h, sk");

    stash.save();


    var config = offerRes.widget_config;
    if ( typeof config === "object" ) {
      widget.config = config;
      wallet.showCodes = !config.hideWalletCodes;
      widget.forceOpenOnCart = config.alwaysShowOnCart;
    } else {
      widget.config = {};
      wallet.showCodes = true;
      widget.forceOpenOnCart = false;
    }

    wallet.offers = _.map(offerRes.offers, function ( item ) {
      var offer = {
        id:              item.incentive_id,
        text:            item.reward,
        minimumPurchase: item.minimum_purchase > 0 ? item.minimum_purchase : 0,
        expires:         item.expiry_timestamp,
        conditions:      item.conditions,
        code:            item.promo_code,
        tempCode:        item.temp_code
      };
      authorizeOffer(offer);

      var link = getOfferLinkObject(item.link_text, item.link_url);
      if ( link ) {
        offer.link = link;
      }

      initOffer(offer);

      return offer;
    });

    if ( offer.delay && !offer.stash.delayed ) {
      setTimeout(function () {
        offer.stash.delayed = 1;
        stash.save();
        initWidget();
      }, offer.delay);
    } else {
      initWidget();
    }
  }

  var widgetApi, loadedWidget;
  function initWidget () {
    if ( widgetApi ) {
      widgetApi.reinitialize();
    } else  if ( !loadedWidget ) {
      loadedWidget = true;
      Loader.load("services/offers-legacy", function ( err, api ) {
        widgetApi = api;
        widgetApi.init(service);
      });
    }
  }

  function initOffer ( offer ) {
    if ( offer.tempCode || offer.code ) {
      if ( typeof Capabilities.applyToCart === "function" ) {
        offer.canApply = true;
      } else if ( applyToCartUrl ) {
        offer.applyToCartUrl = applyToCartUrl.replace("%c", offer.tempCode || offer.code);
        offer.canApply = true;
      }
    }
  }

  function getOfferLinkObject ( text, url ) {
    if ( text && url ) {
      return {
        url: url + (url.indexOf("?") > 0 ? "&" : "?") + "fpst_show=1",
        text: text
      };
    }
  }

  function deputizeOffer ( offer ) {
    depOffers.deputize({
      real: offer.code,
      temp: offer.tempCode
    });
  }

  function processSessionOffer ( code, callback ) {
    sessionOffers.process(code, callback);
  }

  /**
   * @param {Object} offer - An object that resembles an offer
   * @param {String} offer.code - The offer code.
   * @param {String} [offer.tempCode] - The temp code.
   */
  function authorizeOffer ( offer, callback ) {
    if ( offer.tempCode ) {
      deputizeOffer(offer);
    } else {
      processSessionOffer(offer.code, callback);
    }
  }

  function normalizeEmailCollectionMode ( mode ) {
    if ( mode === "N" ) {
      return "never";
    } else if ( mode === "O" ) {
      return "optional";
    }
    return "mandatory";
  }

  function handleExitIntent () {
    platform.once("exitIntent", { init: true }, function ( data ) {
      var o = data.offer;
      if ( o ) {
        var offer = new Offer();
        offer.id = o.id;
        offer.value = o.value;
        offer.code = o.code;
        offer.tempCode = o.tempCode;
        offer.conditions = o.conditions;
        offer.delay = (o.delay || 0) * 1000;
        offer.language = o.language;

        data.offer = offer;
        data.extraCssClasses = o.settings && o.settings.classes || "";

        if ( trackRes ) {
          data.innerCss = trackRes.innerCss;
          data.outerCss = trackRes.outerCss;
        }

        offer.loadState();

        Loader.load("services/intent", function ( err, intentService ) {
          platform.emit("intent:data", [data]);
        });
      }
    });
  }

  function Offer () {
    this.apiVersion = 1;
    this.hasPresented = false;
    this.hasCollected = false;
  }

  Offer.prototype.loadState = function () {
    this.state = stash.get("o." + this.id) || {};
    if (this.apiVersion >= 4) {
      // [v4] The presented state is maintained by the server and assigned by
      // the widget runtime when the offer is created, so do not override these
      // values.
      return;
    }
    this.hasPresented = !!this.state.presented;
    this.hasCollected = !!this.state.collected;
  };

  Offer.prototype.saveState = function () {
    stash.set("o." + this.id, this.state || {}, "2h, sk");
    stash.save();
  };

  Offer.prototype.setPresented = function ( value ) {
    if ( _.isUndefined(value) ) {
      value = 1;
    }
    this.state.presented = 1;
    this.hasPresented = true;
    this.saveState();
  };

  Offer.prototype.setCollected = function ( value ) {
    if ( _.isUndefined(value) ) {
      value = 1;
    }
    this.state.collected = 1;
    this.hasCollected = true;
    this.saveState();
  };

  Offer.prototype.getApplyToCartUrl = function () {
    return applyToCartUrl && applyToCartUrl.replace("%c", this.tempCode || this.code);
  };

  Offer.prototype.applyToCart = function(callback) {
    var that = this;
    var doWait = false;

    var event = {
      type: "offer:apply",
      prevented: false,
      code: that.code,
      tempCode: that.tempCode,
      applyToCartUrl: that.getApplyToCartUrl(),
      preventDefault: function () {
        event.prevented = true;
      }
    };

    function invokeCallback() {
      if (callback) {
        callback();
        callback = null;
      }
    }

    var applyToCart = Capabilities.applyToCart;
    if (typeof applyToCart === "function") {
      if (applyToCart.length > 1) {
        // Legacy: handler accepts doneFn as second argument
        doWait = true;
        applyToCart(event, invokeCallback);
      } else {
        var result = applyToCart(event);
        if (result && typeof result.then === "function") {
          // Modern: handler returned a Promise
          doWait = true;
          result.then(invokeCallback, invokeCallback);
        }
      }
    } else {
      platform.emit("offer:apply", [event], function () {
        if (!event.prevented && event.applyToCartUrl) {
          window.top.location = event.applyToCartUrl;
        }
      });
    }
    if (!doWait) {
      invokeCallback();
    }
  };

  Offer.prototype.canApplyToCart = function () {
    return typeof Capabilities.applyToCart === "function" || this.getApplyToCartUrl();
  };

  /**
   * Authorizes the offer for this session using the deputization or session
   * offer capabilitiy if available.
   *
   * @param {Function} [callback] - Optional callback to invoke when complete.
   */
  Offer.prototype.authorize = function ( callback ) {
    if ( this.tempCode ) {
      this.deputize();
      if ( callback ) {
        callback();
      }
    } else {
      this.enableForSession(callback);
    }
  };

  Offer.prototype.deputize = function () {
    depOffers.deputize({
      // Widget runtime has to override `code` to be the temp code
      // if there is one and assigns the actual code to `realCode`.
      real: this.realCode || this.code,
      // real: this.code,

      temp: this.tempCode
    });
  };

  /**
   * Attempts to enable the offer for the current session
   * if session offers are implemented. Otherwise, does nothing.
   */
  Offer.prototype.enableForSession = function ( callback ) {
    processSessionOffer(this.code, callback);
  };

  Offer.prototype.collect = function ( callback, email ) {
    var self = this;
    service.requestCode(self, email || null, function ( err, res ) {
      if ( !err ) {
        self.setPresented();
        self.setCollected();
      }
      callback(err, res);
    });
  };

  return service;
});

}());